<script setup lang="ts">
import { onHide, onLaunch, onShow } from '@dcloudio/uni-app'
import { usePageAuth } from '@/hooks/usePageAuth'
import { useAppSettingStore, usePermissionStore, useUserStore } from '@/store'
import { Sign } from './interceptors/signAuth'
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'

usePageAuth()

const userStore = useUserStore()
const permissionStore = usePermissionStore()
const appSettingStore = useAppSettingStore()

/**
 * 初始化权限菜单
 * 如果用户已登录，则获取权限菜单
 */
async function initPermissionMenu() {
  try {
    // 判断用户是否已登录
    if (userStore.isLogin()) {
      await permissionStore.fetchPermissionMenu()
    }
  }
  catch (error) {
    console.error('初始化权限菜单失败:', error)
  }
}

function checkUpdateVersion() {
  // 判断微信版本是否 兼容小程序更新机制API的使用
  if (wx.canIUse('getUpdateManager')) {
    const updateManager = wx.getUpdateManager()
    // 检测版本更新
    updateManager?.onCheckForUpdate((res) => {
      if (res.hasUpdate) {
        updateManager.onUpdateReady(() => {
          wx.showModal({
            title: '温馨提示',
            content: '检测到新版本，是否重启小程序？',
            showCancel: false,
            success(res) {
              if (res.confirm) {
                // 新的版本已经下载好，调用 applyUpdate 应用新版本并重启
                updateManager.applyUpdate()
              }
            },
          })
        })
        updateManager.onUpdateFailed(() => {
          // 新版本下载失败
          wx.showModal({
            title: '已有新版本',
            content: '请您删除小程序，重新搜索进入',
          })
        })
      }
    })
  }
  else {
    wx.showModal({
      title: '溫馨提示',
      content:
        '当前微信版本过低，无法使用该功能，请升级到最新微信版本后重试。',
    })
  }
}

// 初始化完成时触发（全局只触发一次）
onLaunch(() => {
  // 设置时间差
  Sign.getTimeDifference()
  // 拉取存储桶全局功能配置
  appSettingStore.fetchRemoteSetting()






})
onShow(() => {
  // getTimeDifference()
})
onHide(() => {
})
</script>

<style lang="scss">
button::after {
  border: none;
}

swiper,
scroll-view {
  flex: 1;
  height: 100%;
  overflow: hidden;
}

image {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

// 单行省略
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 两行省略
.ellipsis-2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

// 三行省略
.ellipsis-3 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
